__turbopack_context__.v({
  "chevron": "Overlay-module-scss-module__uxNbAq__chevron",
  "closeButton": "Overlay-module-scss-module__uxNbAq__closeButton",
  "closeIcon": "Overlay-module-scss-module__uxNbAq__closeIcon",
  "contentWrapper": "Overlay-module-scss-module__uxNbAq__contentWrapper",
  "copy": "Overlay-module-scss-module__uxNbAq__copy",
  "cta": "Overlay-module-scss-module__uxNbAq__cta",
  "eyebrow": "Overlay-module-scss-module__uxNbAq__eyebrow",
  "fade-in": "Overlay-module-scss-module__uxNbAq__fade-in",
  "headline": "Overlay-module-scss-module__uxNbAq__headline",
  "image": "Overlay-module-scss-module__uxNbAq__image",
  "image-square": "Overlay-module-scss-module__uxNbAq__image-square",
  "imageWrapper": "Overlay-module-scss-module__uxNbAq__imageWrapper",
  "inner": "Overlay-module-scss-module__uxNbAq__inner",
  "isClosing": "Overlay-module-scss-module__uxNbAq__isClosing",
  "isOpen": "Overlay-module-scss-module__uxNbAq__isOpen",
  "root": "Overlay-module-scss-module__uxNbAq__root",
  "theme-cream-cheese": "Overlay-module-scss-module__uxNbAq__theme-cream-cheese",
  "theme-holiday": "Overlay-module-scss-module__uxNbAq__theme-holiday",
  "theme-shreds": "Overlay-module-scss-module__uxNbAq__theme-shreds",
});
